import { render } from "./SideBySideImageGalleriesPreview.vue?vue&type=template&id=05a64a32&scoped=true"
import script from "./SideBySideImageGalleriesPreview.vue?vue&type=script&lang=js"
export * from "./SideBySideImageGalleriesPreview.vue?vue&type=script&lang=js"

import "./SideBySideImageGalleriesPreview.vue?vue&type=style&index=0&id=05a64a32&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05a64a32"]])

export default __exports__